module.exports = __webpack_public_path__ + "static/media/sharing.2dcbd7e2.jpg";